export default __webpack_public_path__ + "static/media/qr-frame.dd51840e.svg";